module.exports = __webpack_public_path__ + "img/type_card.6d33b964.png";